import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M5 3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1m6.002 2.998c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1m4.958 7.721c-.46-1.581-1.272-3.563-3.13-4.36.708-.549 1.172-1.398 1.172-2.361 0-1.654-1.346-3-3-3-1.649 0-2.99 1.338-2.998 2.985-.323-.262-.698-.489-1.129-.66C7.556 5.772 8 4.941 8 4c0-1.654-1.346-3-3-3S2 2.346 2 4c0 .971.471 1.827 1.188 2.376C1.328 7.185.51 9.145.042 10.71c-.158.529.143 1.086.672 1.244.096.028.191.042.286.042.431 0 .828-.28.958-.714.697-2.334 1.608-3.286 3.143-3.286 1.295 0 2.12.663 2.77 2.239-.975.965-1.495 2.331-1.83 3.484-.155.53.148 1.086.68 1.24.53.155 1.085-.149 1.24-.68.84-2.883 1.957-3.28 3.04-3.28 1.081 0 2.198.397 3.04 3.28.126.437.525.72.96.72.091 0 .186-.013.28-.04.53-.154.833-.71.68-1.24"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M16 8.999c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M7.998 4c1.103 0 2 .897 2 2s-.897 2-2 2c-1.102 0-2-.897-2-2s.898-2 2-2m14.96 16.719c-.689-2.362-1.914-5.356-4.792-6.366C19.267 13.64 20 12.406 20 10.999c0-2.206-1.794-4-4-4-2.023 0-3.683 1.515-3.946 3.467-.528-.458-1.158-.843-1.903-1.106 1.108-.712 1.847-1.948 1.847-3.36 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.407.734 2.642 1.836 3.354-2.88 1.01-4.105 4.005-4.794 6.368-.154.53.15 1.086.68 1.24.093.027.187.04.28.04.434 0 .833-.283.96-.72 1.08-3.701 2.587-5.28 5.04-5.28 2.163 0 3.552 1.204 4.593 3.959-2.015 1.322-2.975 3.766-3.556 5.758-.154.53.151 1.086.68 1.24.094.027.188.04.28.04.434 0 .833-.283.96-.72 1.08-3.701 2.586-5.28 5.04-5.28 2.453 0 3.96 1.579 5.04 5.28.154.529.702.834 1.24.68.531-.154.834-.71.68-1.24"
        />
      </g>
    </svg>
  ),
};
